import { render, staticRenderFns } from "./RewardsCard.vue?vue&type=template&id=52196b4a&scoped=true"
import script from "./RewardsCard.vue?vue&type=script&lang=js"
export * from "./RewardsCard.vue?vue&type=script&lang=js"
import style0 from "./RewardsCard.vue?vue&type=style&index=0&id=52196b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52196b4a",
  null
  
)

export default component.exports